import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["data", "index", "isExpanded", "isStriped", "expandableContentHasBackgroundColor", "expandableRowHasTopBorder", "isSorted", "spacing", "columns", "maxExpandableRows", "ariaLabel", "actionColumnIndex", "isActionCustomPosition"];
import React from 'react';
import { TdElement as Td, TrElement as Tr } from "../html";
import { ExpandableColumn } from "./ExpandableColumn";
import { jsx as ___EmotionJSX } from "@emotion/core";
export var ExpandableRowsByColumn = function ExpandableRowsByColumn(_ref) {
  var data = _ref.data,
      index = _ref.index,
      isExpanded = _ref.isExpanded,
      isStriped = _ref.isStriped,
      expandableContentHasBackgroundColor = _ref.expandableContentHasBackgroundColor,
      expandableRowHasTopBorder = _ref.expandableRowHasTopBorder,
      isSorted = _ref.isSorted,
      spacing = _ref.spacing,
      columns = _ref.columns,
      maxExpandableRows = _ref.maxExpandableRows,
      ariaLabel = _ref.ariaLabel,
      actionColumnIndex = _ref.actionColumnIndex,
      isActionCustomPosition = _ref.isActionCustomPosition,
      trProps = _objectWithoutProperties(_ref, _excluded);

  return ___EmotionJSX(React.Fragment, null, _toConsumableArray(Array(maxExpandableRows)).map(function (_, expandableRowIndex) {
    return ___EmotionJSX(Tr, _extends({}, trProps, {
      key: expandableRowIndex,
      isExpandableContent: true,
      hasBackgroundColor: isStriped || expandableContentHasBackgroundColor,
      hasTopBorderWhenExpanded: expandableRowHasTopBorder && isExpanded
    }), columns.map(function (column, index) {
      return ___EmotionJSX(ExpandableColumn, {
        key: index,
        expandableRowIndex: expandableRowIndex,
        actionColumnIndex: actionColumnIndex,
        ariaLabel: ariaLabel,
        colIndex: index,
        columns: columns,
        data: data,
        expandableRowHasTopBorder: expandableRowHasTopBorder,
        isActionCustomPosition: isActionCustomPosition,
        isExpanded: isExpanded,
        isSorted: isSorted,
        isStriped: isStriped,
        spacing: spacing,
        columnProps: column
      });
    }), // Add an empty action cell if actionColumnIndex is not passed
    !isActionCustomPosition && ___EmotionJSX(Td, null));
  }));
};